import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ethers } from "ethers";
import { Web3ReactProvider } from "@web3-react/core";

function getWeb3Library(provider: any, connector: any) {
  let lib;
  lib = new ethers.providers.Web3Provider(provider);
  // lib = new ethers.providers.getDefaultProviderr();
  //
  // else {
  //   lib = new ethers.providers.Web3Provider(provider);
  //   if (!lib) {
  //     lib = new ethers.providers.InfuraProvider("kovan", "f53a89bfad1c4d258ca5d9d5c49f9f1f");
  //   }
  // }
  // const lib = new ethers.providers.InfuraProvider(
  //   "kovan",
  //   "f53a89bfad1c4d258ca5d9d5c49f9f1f"
  // );

  lib.pollingInterval = 12000;
  return lib;
}

ReactDOM.render(
  <React.StrictMode>
    <Web3ReactProvider getLibrary={getWeb3Library}>
      <App />
    </Web3ReactProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
